// Blocks shown at the top of the footer: call-to-action cards (FooterCta*) and rows of link
// cards (FooterLinks*). Each page passes its combination to SiteLayout as footerCta.

import { NavLink } from '@components/webflow';

export function FooterCtaBuildYourReliableBackend() {
  return (
    <div className="footer-cta-wrapper">
      <div className="footer-cta-container">
        <h3 className="text-heading-h3">
          {'Build your reliable backend. '}
          <br />
          Effortlessly.
          <br />
        </h3>
        <div className="button-row-horizontal">
          <NavLink href="/contact" className="button-cta button-secondary w-inline-block">
            <div className="text-block">Contact sales</div>
          </NavLink>
          <div className="button-primary-border">
            <a href="https://console.dbos.dev/" className="button-cta button-primary button-navigation w-inline-block">
              <div className="text-block">Start your project</div>
            </a>
          </div>
        </div>
      </div>
      <div className="cta_card is-major">
        <div className="max-width-large">
          <div className="cta_container">
            <div className="margin-bottom margin-xsmall">
              <h2 className="heading-style-h2">Get started with DBOS</h2>
            </div>
            <div className="max-width-medium">
              <div className="margin-bottom margin-xsmall">
                <p className="text-body-active">
                  Use the open source DBOS Transact library, free forever. Pair it with DBOS Pro for premium tooling and
                  support.
                </p>
              </div>
            </div>
            <div className="button-group">
              <div data-wf--button--variant="primary-large" className="button-wrapper">
                <a href="https://console.dbos.dev/" className="button w-inline-block">
                  <div className="text-block-4">Start for free</div>
                  <div className="icon-chevron-right w-embed">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                        fill="#F3F6F8"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </a>
              </div>
              <div
                data-wf--button--variant="secondary-large"
                className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
              >
                <NavLink
                  href="/dbos-pricing"
                  className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                >
                  <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Explore plans</div>
                  <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                        fill="#F3F6F8"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function FooterCtaStartBuildingForFree() {
  return (
    <div className="w-layout-hflex footer-cta-col-2">
      <div className="cta_card is-mini">
        <div className="max-width-xlarge">
          <div className="div-block-46">
            <h2 className="heading-style-h3">Start building for free</h2>
            <p className="text-body-active newhomebody">
              Use the open source DBOS Transact library, free forever. Pair it with a free 30-day trial of DBOS Pro
              tooling and support.
            </p>
            <div className="cta45_card-benefits">
              <div className="benefit-item">
                <div className="w-embed">
                  <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {'\n'}
                    <g filter="url(#filter0_d_8333_5019)">
                      {'\n'}
                      <path
                        d="M2 5.18631C2 2.69036 4.02337 0.666992 6.51932 0.666992H25.4807C27.9766 0.666992 30 2.69036 30 5.18631V24.1477C30 26.6436 27.9766 28.667 25.4807 28.667H6.51932C4.02337 28.667 2 26.6436 2 24.1477V5.18631Z"
                        fill="#090D15"
                        shapeRendering="crispEdges"
                      />
                      {'\n'}
                      <path
                        d="M6.51953 1.16699H25.4805C27.7003 1.16699 29.5 2.96672 29.5 5.18652V24.1475C29.5 26.3673 27.7003 28.167 25.4805 28.167H6.51953C4.29972 28.167 2.5 26.3673 2.5 24.1475V5.18652C2.5 2.96672 4.29972 1.16699 6.51953 1.16699Z"
                        stroke="#3C4B62"
                        shapeRendering="crispEdges"
                      />
                      {'\n'}
                      <path
                        d="M22.3217 14.0833L16.307 10.75C16.2083 10.6952 16.0973 10.6665 15.9844 10.6663C15.8716 10.6662 15.7605 10.6948 15.6617 10.7493L9.67635 14.056C9.57221 14.1135 9.48536 14.1978 9.42482 14.3002C9.36427 14.4027 9.33224 14.5194 9.33203 14.6384C9.33183 14.7573 9.36346 14.8742 9.42366 14.9768C9.48385 15.0794 9.57041 15.1641 9.67435 15.222L15.689 18.582C15.788 18.6376 15.8997 18.6669 16.0133 18.667C16.1268 18.6671 16.2385 18.6381 16.3377 18.5826L22.323 15.2493C22.427 15.1915 22.5136 15.1069 22.5738 15.0043C22.6341 14.9017 22.6658 14.7849 22.6657 14.6659C22.6655 14.5469 22.6336 14.4302 22.5731 14.3277C22.5126 14.2253 22.4258 14.1409 22.3217 14.0833ZM16.0143 17.2366L11.3717 14.6433L15.983 12.0953L20.6257 14.668L16.0143 17.2366Z"
                        fill="#F3F6F8"
                      />
                      {'\n'}
                      <path
                        d="M15.999 21.3333C16.1122 21.3334 16.2235 21.3045 16.3223 21.2493L22.3223 17.916L21.675 16.7507L15.999 19.904L10.3223 16.7507L9.67501 17.916L15.675 21.2493C15.7741 21.3044 15.8856 21.3333 15.999 21.3333ZM21.3323 8H19.999V9.33333H18.6657V10.6667H19.999V12H21.3323V10.6667H22.6657V9.33333H21.3323V8Z"
                        fill="#F3F6F8"
                      />
                      {'\n'}
                    </g>
                    {'\n'}
                    <defs>
                      {'\n'}
                      <filter
                        id="filter0_d_8333_5019"
                        x="-2.38419e-07"
                        y="0.666992"
                        width="30"
                        height="28"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        {'\n'}
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        {'\n'}
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        {'\n'}
                        <feOffset dx="-2" />
                        {'\n'}
                        <feComposite in2="hardAlpha" operator="out" />
                        {'\n'}
                        <feColorMatrix type="matrix" values="0 0 0 0 0.036 0 0 0 0 0.052 0 0 0 0 0.084 0 0 0 1 0" />
                        {'\n'}
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8333_5019" />
                        {'\n'}
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8333_5019" result="shape" />
                        {'\n'}
                      </filter>
                      {'\n'}
                    </defs>
                    {'\n'}
                  </svg>
                </div>
                <div className="text-size-small">Build with your stack</div>
              </div>
              <div className="benefit-item">
                <div className="w-embed">
                  <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {'\n'}
                    <g filter="url(#filter0_d_8333_5003)">
                      {'\n'}
                      <path
                        d="M2 5.18631C2 2.69036 4.02337 0.666992 6.51932 0.666992H25.4807C27.9766 0.666992 30 2.69036 30 5.18631V24.1477C30 26.6436 27.9766 28.667 25.4807 28.667H6.51932C4.02337 28.667 2 26.6436 2 24.1477V5.18631Z"
                        fill="#090D15"
                        shapeRendering="crispEdges"
                      />
                      {'\n'}
                      <path
                        d="M6.51953 1.16699H25.4805C27.7003 1.16699 29.5 2.96672 29.5 5.18652V24.1475C29.5 26.3673 27.7003 28.167 25.4805 28.167H6.51953C4.29972 28.167 2.5 26.3673 2.5 24.1475V5.18652C2.5 2.96672 4.29972 1.16699 6.51953 1.16699Z"
                        stroke="#3C4B62"
                        shapeRendering="crispEdges"
                      />
                      {'\n'}
                      <path
                        d="M21.9963 11.2671C21.9852 11.1551 21.9459 11.0477 21.882 10.955C21.8181 10.8623 21.7317 10.7874 21.631 10.7371L16.2976 8.07048C16.205 8.02413 16.1029 8 15.9993 8C15.8957 8 15.7936 8.02413 15.701 8.07048L10.3676 10.7371C10.2672 10.7876 10.181 10.8627 10.1173 10.9554C10.0535 11.048 10.0142 11.1552 10.003 11.2671C9.99564 11.3385 9.3623 18.4451 15.729 21.2765C15.814 21.3149 15.9063 21.3347 15.9996 21.3347C16.093 21.3347 16.1852 21.3149 16.2703 21.2765C22.637 18.4451 22.0036 11.3391 21.9963 11.2671ZM15.9996 19.9318C11.487 17.7505 11.2736 13.0951 11.3103 11.7571L15.9996 9.41248L20.6856 11.7558C20.7103 13.0818 20.467 17.7678 15.9996 19.9318Z"
                        fill="#F3F6F8"
                      />
                      {'\n'}
                      <path
                        d="M15.333 15.0578L13.8043 13.5292L12.8617 14.4718L15.333 16.9432L19.1377 13.1385L18.195 12.1958L15.333 15.0578Z"
                        fill="#F3F6F8"
                      />
                      {'\n'}
                    </g>
                    {'\n'}
                    <defs>
                      {'\n'}
                      <filter
                        id="filter0_d_8333_5003"
                        x="-2.38419e-07"
                        y="0.666992"
                        width="30"
                        height="28"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        {'\n'}
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        {'\n'}
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        {'\n'}
                        <feOffset dx="-2" />
                        {'\n'}
                        <feComposite in2="hardAlpha" operator="out" />
                        {'\n'}
                        <feColorMatrix type="matrix" values="0 0 0 0 0.036 0 0 0 0 0.052 0 0 0 0 0.084 0 0 0 1 0" />
                        {'\n'}
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8333_5003" />
                        {'\n'}
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8333_5003" result="shape" />
                        {'\n'}
                      </filter>
                      {'\n'}
                    </defs>
                    {'\n'}
                  </svg>
                </div>
                <div className="text-size-small">SOC 2 Compliant</div>
              </div>
            </div>
          </div>
        </div>
        <div className="button-group">
          <div data-wf--button--variant="primary-large" className="button-wrapper">
            <a href="https://console.dbos.dev/" className="button w-inline-block">
              <div className="text-block-4">Start building</div>
              <div className="icon-chevron-right w-embed">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {'\n'}
                  <path
                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                    fill="#F3F6F8"
                  />
                  {'\n'}
                </svg>
              </div>
            </a>
          </div>
          <div
            data-wf--button--variant="secondary-large"
            className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
          >
            <NavLink href="/contact" className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block">
              <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Request a demo</div>
              <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {'\n'}
                  <path
                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                    fill="#F3F6F8"
                  />
                  {'\n'}
                </svg>
              </div>
            </NavLink>
          </div>
        </div>
      </div>
      <div className="cta_card is-mini">
        <div className="max-width-xlarge">
          <div className="div-block-46">
            <h2 className="heading-style-h3">Join our team</h2>
            <p className="text-body-active newhomebody">
              Star in a team that's helping more brands and developers launch reliable software effortlessly.
            </p>
          </div>
        </div>
        <div className="button-group">
          <div
            data-wf--button--variant="secondary-large"
            className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
          >
            <NavLink href="/jobs" className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block">
              <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Browse open positions</div>
              <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {'\n'}
                  <path
                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                    fill="#F3F6F8"
                  />
                  {'\n'}
                </svg>
              </div>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export function FooterLinksFollowOurGithub() {
  return (
    <div className="card-link-row">
      <a href="https://github.com/dbos-inc/" className="card-link-item w-inline-block">
        <div className="text-heading-h4">Follow our GitHub</div>
        <div className="w-embed">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            {'\n'}
            <path
              d="M7 17.5L17 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
            <path
              d="M7 7.5H17V17.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
          </svg>
        </div>
      </a>
      <a href="https://discord.com/invite/jsmC6pXGgX" target="_blank" className="card-link-item w-inline-block">
        <div className="text-heading-h4">Join our Discord</div>
        <div className="w-embed">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            {'\n'}
            <path
              d="M7 17.5L17 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
            <path
              d="M7 7.5H17V17.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
          </svg>
        </div>
      </a>
      <NavLink href="/contact" className="card-link-item w-inline-block">
        <div className="text-heading-h4">Get in touch</div>
        <div className="w-embed">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            {'\n'}
            <path
              d="M7 17.5L17 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
            <path
              d="M7 7.5H17V17.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
          </svg>
        </div>
      </NavLink>
    </div>
  );
}

export function FooterLinksFollowOurGithub2() {
  return (
    <div className="card-link-row">
      <a href="#" target="_blank" className="card-link-item w-inline-block">
        <div className="text-heading-h4">Follow our GitHub</div>
        <div className="w-embed">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            {'\n'}
            <path
              d="M7 17.5L17 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
            <path
              d="M7 7.5H17V17.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
          </svg>
        </div>
      </a>
      <a href="https://discord.com/invite/jsmC6pXGgX" target="_blank" className="card-link-item w-inline-block">
        <div className="text-heading-h4">Join our Discord</div>
        <div className="w-embed">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            {'\n'}
            <path
              d="M7 17.5L17 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
            <path
              d="M7 7.5H17V17.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
          </svg>
        </div>
      </a>
      <NavLink href="/contact" className="card-link-item w-inline-block">
        <div className="text-heading-h4">Get in touch</div>
        <div className="w-embed">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            {'\n'}
            <path
              d="M7 17.5L17 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
            <path
              d="M7 7.5H17V17.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
          </svg>
        </div>
      </NavLink>
    </div>
  );
}

export function FooterLinksFollowOurGithub3() {
  return (
    <div className="card-link-row">
      <a href="https://github.com/dbos-inc/" target="_blank" className="card-link-item w-inline-block">
        <div className="text-heading-h4">Follow our GitHub</div>
        <div className="w-embed">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            {'\n'}
            <path
              d="M7 17.5L17 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
            <path
              d="M7 7.5H17V17.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
          </svg>
        </div>
      </a>
      <a href="https://discord.com/invite/jsmC6pXGgX" target="_blank" className="card-link-item w-inline-block">
        <div className="text-heading-h4">Join our Discord</div>
        <div className="w-embed">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            {'\n'}
            <path
              d="M7 17.5L17 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
            <path
              d="M7 7.5H17V17.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
          </svg>
        </div>
      </a>
      <NavLink href="/contact" className="card-link-item w-inline-block">
        <div className="text-heading-h4">Get in touch</div>
        <div className="w-embed">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            {'\n'}
            <path
              d="M7 17.5L17 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
            <path
              d="M7 7.5H17V17.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
          </svg>
        </div>
      </NavLink>
    </div>
  );
}

export function FooterLinksSendUsMail() {
  return (
    <div className="card-link-row">
      <a href="https://maps.app.goo.gl/r8Vv4ACwrXtuWLYR7" target="_blank" className="card-link-item w-inline-block">
        <div className="text-heading-h4">Send us mail</div>
        <div className="w-embed">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            {'\n'}
            <path
              d="M7 17.5L17 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
            <path
              d="M7 7.5H17V17.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
          </svg>
        </div>
      </a>
      <NavLink href="/jobs" className="card-link-item w-inline-block">
        <div className="text-heading-h4">Browse jobs at DBOS</div>
        <div className="w-embed">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            {'\n'}
            <path
              d="M7 17.5L17 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
            <path
              d="M7 7.5H17V17.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
          </svg>
        </div>
      </NavLink>
      <NavLink href="/about" className="card-link-item w-inline-block">
        <div className="text-heading-h4">Meet our team</div>
        <div className="w-embed">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            {'\n'}
            <path
              d="M7 17.5L17 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
            <path
              d="M7 7.5H17V17.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {'\n'}
          </svg>
        </div>
      </NavLink>
    </div>
  );
}
